import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import api from '@/admin/lib/api'
import type { ApiKey } from '@/admin/types/api-keys'

const QUERY_KEY = ['api-keys'] as const

export function useApiKeys() {
  const queryClient = useQueryClient()

  const query = useQuery<ApiKey[]>({
    queryKey: QUERY_KEY,
    queryFn: () => api.get('/auth/api-keys/').then((r) => r.data),
    staleTime: 30_000,
  })

  const invalidate = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: QUERY_KEY })
  }, [queryClient])

  return { ...query, invalidate }
}
